module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "config"
    }
  }, [_c('header', {
    attrs: {
      "id": "fi360"
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "open",
    attrs: {
      "id": "start-config"
    }
  }, [_c('h1', [_vm._v("Bonjour "), _c('strong', [_vm._v(_vm._s(_vm.user.last_name + ' ' + _vm.user.first_name))]), _vm._v(" ! ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "btn btn-full next",
    attrs: {
      "id": "next-trigger",
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToSection('add-signature')
      }
    }
  }, [_c('i', {
    staticClass: "icon-tool"
  }), _vm._v(" "), _c('span', [_vm._v("Configurer")]), _vm._v(" "), _c('i', {
    staticClass: "icon-go"
  })])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "add-signature"
    }
  }, [_c('h3', [_vm._v("Ma signature")]), _vm._v(" "), _c('i', {
    staticClass: "icon-checktodo"
  }), _vm._v(" "), _c('p', [_vm._v("\n            Afin de pouvoir signer numériquement vos rapports d'interventions, merci d'enregistrer votre signature manuscrite\n        ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-full add",
    attrs: {
      "id": "signature-trigger"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showModal = true
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('signature-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    on: {
      "close": function($event) {
        _vm.showModal = false
      },
      "signatureUpdated": _vm.saveSignature
    }
  })], 1), _vm._v(" "), _c('section', {
    attrs: {
      "id": "add-photo"
    }
  }, [_c('h3', [_vm._v("Ma photo de profil")]), _vm._v(" "), _c('i', {
    staticClass: "icon-photo"
  }), _vm._v(" "), _c('p', [_vm._v("\n            Afin de bénéficier d'une interface plus personnelle merci de bien vouloir ajouter une photo de profil.\n        ")]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "id": "photoprofil",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    ref: "inputphoto",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "change-photo-profil"
    },
    on: {
      "change": _vm.savePhoto
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-full add",
    attrs: {
      "id": "photo-trigger",
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerPhoto($event)
      }
    }
  }, [_c('span', [_vm._v("Ajouter ma photo")]), _vm._v(" "), _c('i', {
    staticClass: "icon-go"
  })]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "home",
      "id": "ignore"
    }
  }, [_vm._v("Pas maintenant")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Bienvenue sur la page de configuration de votre "), _c('strong', [_vm._v("application F.i360°")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('strong', [_vm._v("Enregistrer")]), _vm._v(" ma signature")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c4d6809","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/Config.vue
// module id = 742
// module chunks = 0